export const getChangeId = (address: string, type: string) => `${address}_${type}`;
